import { useStore } from '@/containers'
import clsx from 'clsx'
import { FormButton } from '../Form'
import { PopupClose } from '../Icon/PopupClose'
import PopupBody from './PopupBody'
import PopupFrame from './PopupFrame'
import PopupTitle from './PopupTitle'

const ModalConfirmChangeRegion = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean
  errorMessage?: string

  setIsOpen: (data: boolean) => void
}) => {
  const { regions, regionChange } = useStore()
  const store = regions.find(e => e.code == regionChange)
  return (
    <PopupFrame
      closeText={'đóng'}
      open={isOpen}
      onClose={() => setIsOpen(true)}
      className='w-[384px] max-w-[384px] bg-white-400 px-4 py-2'
    >
      <PopupTitle className='!h-9 text-base font-bold text-red-800'>
        {
          <div
            onClick={() => setIsOpen(false)}
            className='absolute right-0 top-1.5 cursor-pointer items-center gap-1'
          >
            <PopupClose className='text-dark-400' />
          </div>
        }
        Thay đổi khu vực bán hàng
      </PopupTitle>
      <PopupBody>
        <div className='w-full'>
          <p className='text-sm text-dark-400'>
            Địa chỉ nhận hàng của bạn thuộc khu vực{' '}
            <strong className='font-bold text-dark-900'>{store?.name}. </strong>
            Giỏ hàng của bạn đã được cập nhập theo khu vực này.
          </p>
          <FormButton
            onClick={() => {
              setIsOpen(false)
            }}
            className={clsx(
              'disabled:text-[rgb(0 0 0 / 25%)] float-right ml-auto mr-0 mt-1 h-9 rounded border border-gray-300 px-4 text-sm disabled:outline-none'
            )}
          >
            Đóng
          </FormButton>
        </div>
      </PopupBody>
    </PopupFrame>
  )
}
export default ModalConfirmChangeRegion
